import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '@app/common/modules/base/base.component';
import { ThemeService } from '@infra/theme/theme.service';
import { Campo } from '@components/form/form.component';
import { Coluna } from '@components/table/table.component';
import * as moment from 'moment';
import { DashboardController } from '@modules/dashboard/controllers';
import { IndicadorResult } from '@app/data/indicadores/models/indicadores.model';
import { EChartsOption } from 'echarts';
import { PageEvent } from '@angular/material/paginator';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent extends BaseComponent implements OnInit {
  public isLoading: boolean = true;
  protected filtros: Campo[] = [
    {
      name: 'dataEmissao',
      label: 'Período Emissão',
      type: 'date-range',
      width: '100%',
      value: {
        dataInicial: moment().startOf('month'),
        dataFinal: moment().endOf('month')
      },
      tooltip: 'O filtro de período será aplicado apenas nos indicadores abaixo',
      dateRangeOptions: { icon: 'prefix' },
      validators: [],
    },
  ];
  public cardsSuperiores = [
    { label: 'Idade Média Veículos Locação', icon: 'directions_car', value: 0, suffix: ' Mês(es)', prop: 'indicadorIdadeMediaDaFrota', varVal: 'idadeMediaFrota' },
    { label: 'Medições Pendentes', icon: 'receipt_long', value: 0, suffix: ' Medição(ões)', prop: 'indicadorMedicoesPendentes', varVal: 'totalMedicoesPendentes' },
    { label: 'Veículos Locados', icon: 'local_shipping', value: 0, suffix: ' Veículo(s)', prop: 'indicadorQuantidadeVeiculosAtivos', varVal: 'qtdVeiculos' },
    { label: 'OS\'s Pendentes Aprovação', icon: 'build', value: 0, suffix: ' OS(s)', prop: 'indicadorOSAbertos', varVal: 'totalOSAbertas' }
  ];
  public osChartOptions: EChartsOption = {};
  public atendimentosGeralChartOptions: EChartsOption = {};
  public sinistroChartOptions: EChartsOption = {};
  public atendimentosMesChartOptions: EChartsOption = {};

  public hasOsData = false;
  public hasAtendimentosGeralData = false;
  public hasSinistroData = false;
  public hasAtendimentosMesData = false;
  public infracoesDataAll: any[] = [];
  public multasLocalDataAll: any[] = [];
  public topMultadosDataAll: any[] = [];

  public infracoesData: any[] = [];
  public multasLocalData: any[] = [];
  public topMultadosData: any[] = [];

  public infracoesPaginator   = { length: 0, pageSize: 5, pageIndex: 0, pageSizeOptions: [5, 10, 25] };
  public multasLocalPaginator  = { length: 0, pageSize: 5, pageIndex: 0, pageSizeOptions: [5, 10, 25] };
  public topMultadosPaginator  = { length: 0, pageSize: 5, pageIndex: 0, pageSizeOptions: [5, 10] };

  private currentDataInicial?: string;
  private currentDataFinal?: string;

  private osAbertosVal = 0;
  private osFechadosVal = 0;
  private atendAbertosVal = 0;
  private atendFinalizadosVal = 0;
  private atendAbertosMesVal = 0;
  private atendFinalizadosMesVal = 0;
  private sinistrosAbertosVal = 0;
  private sinistrosFechadosVal = 0;

  public infracoesColumns: Coluna[] = [
    { name: 'codigoInfracao', label: 'Cód. Infração' },
    { name: 'descricao', label: 'Descrição' },
    { name: 'quantidade', label: 'Quantidade' },
  ];

  public multasLocalColumns: Coluna[] = [
    { name: 'local', label: 'Local' },
    { name: 'quantidade', label: 'Quantidade' },
  ];

  public topMultadosColumns: Coluna[] = [
    { name: 'placa', label: 'Placa' },
    { name: 'quantidade', label: 'Quantidade' },
  ];

  get corPrimaria(): string {
    return this.themeService.primaryColor || '#7e22ce';
  }

  get corSecundaria(): string {
    return this.themeService.accentColor || '#fca5a5';
  }

  private indicadoresCards: string[] = [
    'indicadorIdadeMediaDaFrota',
    'indicadorAtendimentosAbertos',
    'indicadorMedicoesPendentes',
    'indicadorQuantidadeVeiculosAtivos',
    'indicadorOSAbertos'
  ];

  private indicadoresGraficos: string[] = [
    'indicadorOSAbertos',
    'indicadorOSFechados',
    'indicadorAtendimentosAbertos',
    'indicadorAtendimentosFinalizados',
    'indicadorAtendimentosAbertosMes',
    'indicadorAtendimentosFinalizadosMes',
    'indicadorSinistrosAbertos',
    'indicadorSinistrosFechados',
  ];

  private indicadoresTabelas: string[] = [
    'indicadorInfracoes',
    'indicadorMultasLocalidade',
    'indicadorVeiculosMaisMultados',
  ];

  constructor(
    private dashboardController: DashboardController,
    public themeService: ThemeService
  ) {
    super('Dashboard - Portal do Cliente');
  }

  override ngOnInit(): void {
    super.ngOnInit();
    
    this.carregarIndicadoresFixos();
    
    this.carregarIndicadoresFiltrados(
      moment().startOf('month').format('YYYY-MM-DD'),
      moment().endOf('month').format('YYYY-MM-DD')
    );
  }

  private carregarIndicadoresFixos(): void {
    this.dashboardController.getIndicadores(this.indicadoresCards).subscribe(
      response => {
        const results = response.data?.results || [];
        this.processarResultados(results);
      },
      () => {}
    );
  }

  private carregarIndicadoresFiltrados(dataInicial?: string, dataFinal?: string): void {
    this.isLoading = true;

    const indicadoresFiltrados = [...new Set([
      ...this.indicadoresGraficos,
      ...this.indicadoresTabelas
    ])];

    this.dashboardController.getIndicadores(indicadoresFiltrados, dataInicial, dataFinal).subscribe(
      response => {
        const results = response.data?.results || [];

        this.infracoesDataAll = [];
        this.infracoesData = [];
        this.infracoesPaginator.length = 0;

        this.multasLocalDataAll = [];
        this.multasLocalData = [];
        this.multasLocalPaginator.length = 0;

        this.topMultadosDataAll = [];
        this.topMultadosData = [];
        this.topMultadosPaginator.length = 0;

        this.processarResultados(results);
        this.isLoading = false;
      },
      () => {
        this.inicializarGraficosMock();
        this.isLoading = false;
      }
    );
  }

  private processarResultados(results: IndicadorResult[][]): void {

    results.forEach((arr: IndicadorResult[]) => {
      if (!arr || arr.length === 0) return;

      const indicadorNome = arr[0].indicador;

      switch (indicadorNome) {
        case 'indicadorIdadeMediaDaFrota':
        case 'indicadorAtendimentosAbertos':
        case 'indicadorMedicoesPendentes':
        case 'indicadorQuantidadeVeiculosAtivos':
        case 'indicadorOSAbertos': {
          const item = arr[0];
          const cardRef = this.cardsSuperiores.find(c => c.prop === indicadorNome);
          if (cardRef && item[cardRef.varVal] !== undefined) {
            cardRef.value = item[cardRef.varVal];
          }

          if (indicadorNome === 'indicadorOSAbertos') {
            this.osAbertosVal = item['totalOSAbertas'] || 0;
          }

          if (indicadorNome === 'indicadorAtendimentosAbertos') {
            this.atendAbertosVal = item['qtdAtendimentosAbertos'] || 0;
          }
          break;
        }

        case 'indicadorOSFechados': {
          this.osFechadosVal = arr[0]['totalOSFechadas'] || arr[0]['value'] || 0;
          break;
        }

        case 'indicadorAtendimentosFinalizados': {
          this.atendFinalizadosVal = arr[0]['qtdAtendimentosFinalizados'] || arr[0]['value'] || 0;
          break;
        }

        case 'indicadorAtendimentosAbertosMes': {
          this.atendAbertosMesVal = arr[0]['qtdAtendimentosAbertosMes'] || arr[0]['value'] || 0;
          break;
        }

        case 'indicadorAtendimentosFinalizadosMes': {
          this.atendFinalizadosMesVal = arr[0]['qtdAtendimentosFinalizadosmes'] || arr[0]['qtdAtendimentosFinalizadosMes'] || 0;
          break;
        }

        case 'indicadorSinistrosAbertos': {
          this.sinistrosAbertosVal = arr[0]['qtdSinistrosAbertos'] || arr[0]['value'] || 0;
          break;
        }

        case 'indicadorSinistrosFechados': {
          this.sinistrosFechadosVal = arr[0]['qtdSinistrosFechados'] || arr[0]['value'] || 0;
          break;
        }

        case 'indicadorInfracoes': {
          this.infracoesDataAll = arr.map(item => ({
            codigoInfracao: item['codigoInfracao'] || '',
            descricao: item['descricao'] || '',
            quantidade: item['qtdInfracoes'] || 0
          }));
          this.infracoesPaginator.length = this.infracoesDataAll.length;
          this.infracoesData = this.paginateData(this.infracoesDataAll, this.infracoesPaginator);
          break;
        }

        case 'indicadorMultasLocalidade': {
          this.multasLocalDataAll = arr.map(item => ({
            local: item['descricao'] || '',
            quantidade: item['qtdMultasLocalidade'] || 0
          }));
          this.multasLocalPaginator.length = this.multasLocalDataAll.length;
          this.multasLocalData = this.paginateData(this.multasLocalDataAll, this.multasLocalPaginator);
          break;
        }

        case 'indicadorVeiculosMaisMultados': {
          this.topMultadosDataAll = arr.map(item => ({
            placa: item['placa'] || '',
            quantidade: item['qtdMultasVeiculo'] || 0
          }));
          this.topMultadosPaginator.length = this.topMultadosDataAll.length;
          this.topMultadosData = this.paginateData(this.topMultadosDataAll, this.topMultadosPaginator);
          break;
        }
      }
    });

    this.montarGraficos(
      this.osAbertosVal, this.osFechadosVal,
      this.atendAbertosVal, this.atendFinalizadosVal,
      this.atendAbertosMesVal, this.atendFinalizadosMesVal,
      this.sinistrosAbertosVal, this.sinistrosFechadosVal
    );
  }

  private montarGraficos(
    osAbertos: number, osFechados: number,
    atendAbertos: number, atendFinalizados: number,
    atendAbertosMes: number, atendFinalizadosMes: number,
    sinistrosAbertos: number, sinistrosFechados: number
  ): void {
    this.hasOsData = (osAbertos + osFechados) > 0;
    this.hasAtendimentosGeralData = (atendAbertos + atendFinalizados) > 0;
    this.hasSinistroData = (sinistrosAbertos + sinistrosFechados) > 0;
    this.hasAtendimentosMesData = (atendAbertosMes + atendFinalizadosMes) > 0;

    if (this.hasOsData) {
      this.osChartOptions = this.criarGraficoBarras(osAbertos, osFechados);
    }
    if (this.hasAtendimentosGeralData) {
      this.atendimentosGeralChartOptions = this.criarGraficoRosca(atendAbertos, atendFinalizados);
    }
    if (this.hasSinistroData) {
      this.sinistroChartOptions = this.criarGraficoRosca(sinistrosAbertos, sinistrosFechados);
    }
    if (this.hasAtendimentosMesData) {
      this.atendimentosMesChartOptions = this.criarGraficoRosca(atendAbertosMes, atendFinalizadosMes);
    }
  }

  private criarGraficoBarras(abertos: number, fechados: number): EChartsOption {
    const total = abertos + fechados;
    const maxEscala = total > 0 ? total : 1; 

    return {
      tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, appendToBody: true },
      grid: { left: '5%', right: '10%', bottom: '5%', top: '5%', containLabel: true },
      xAxis: { 
        type: 'value', 
        show: false,
        max: maxEscala
      },
      yAxis: { 
        type: 'category', 
        data: ['Fechadas', 'Abertas'], 
        show: true,
        axisLine: { show: false },
        axisTick: { show: false },
        axisLabel: { color: '#666', fontWeight: 'bold' }
      },
      series: [
        {
          name: 'OS',
          type: 'bar',
          barWidth: '50%',
          showBackground: true,
          backgroundStyle: { color: 'rgba(180, 180, 180, 0.2)', borderRadius: 4 },
          data: [
            { value: fechados, name: 'Fechadas', itemStyle: { color: this.corSecundaria, borderRadius: 4 } },
            { value: abertos, name: 'Abertas', itemStyle: { color: this.corPrimaria, borderRadius: 4 } }
          ],
          label: { 
            show: true, 
            position: 'right',
            color: '#333', 
            fontWeight: 'bold',
            formatter: '{c}'
          }
        }
      ]
    };
  }

  private criarGraficoRosca(abertos: number, fechados: number): EChartsOption {
    const total = abertos + fechados;

    return {
      tooltip: { trigger: 'item', appendToBody: true },
      legend: {
        orient: 'vertical',
        right: '2%',
        top: 'center',
        itemWidth: 12,
        itemHeight: 12,
        itemGap: 12,
        textStyle: { fontSize: 11 },
        formatter: (name: string) => {
          const value = name === 'Aberto(s)' ? abertos : fechados;
          const pct = total > 0 ? ((value / total) * 100).toFixed(1) : '0.0';
          return `${name}\n${value} - ${pct}%`;
        }
      },
      series: [
        {
          name: 'Atendimentos',
          type: 'pie',
          radius: ['45%', '95%'],
          center: ['30%', '50%'],
          avoidLabelOverlap: false,
          label: {
            show: true,
            position: 'center',
            fontSize: 22,
            fontWeight: 'bold',
            color: '#333',
            formatter: () => `${total}`
          },
          labelLine: { show: false },
          data: [
            { value: abertos, name: 'Aberto(s)', itemStyle: { color: this.corPrimaria } },
            { value: fechados, name: 'Fechado(s)', itemStyle: { color: this.corSecundaria } }
          ]
        }
      ]
    };
  }

  private inicializarGraficosMock(): void {
    this.osChartOptions = this.criarGraficoBarras(8, 45);
    this.atendimentosGeralChartOptions = this.criarGraficoRosca(27, 40);
    this.sinistroChartOptions = this.criarGraficoRosca(15, 60);
    this.atendimentosMesChartOptions = this.criarGraficoRosca(12, 10);
  }

  public filtrar(search?: string): void {
    this.carregarIndicadoresFixos();

    this.infracoesPaginator.pageIndex = 0;
    this.multasLocalPaginator.pageIndex = 0;
    this.topMultadosPaginator.pageIndex = 0;

    if (search === '') {
      this.currentDataInicial = undefined;
      this.currentDataFinal = undefined;
      this.carregarIndicadoresFiltrados(undefined, undefined);
      return;
    }

    let dataInicial = moment().startOf('month').format('YYYY-MM-DD');
    let dataFinal   = moment().endOf('month').format('YYYY-MM-DD');

    if (search) {
      const match = search.match(/dataEmissao=([^&]+)\.\.([^&]+)/);
      if (match) {
        dataInicial = moment.utc(match[1]).format('YYYY-MM-DD');
        dataFinal   = moment.utc(match[2]).format('YYYY-MM-DD');
      }
    }

    this.currentDataInicial = dataInicial;
    this.currentDataFinal = dataFinal;
    this.carregarIndicadoresFiltrados(dataInicial, dataFinal);
  }

  private paginateData(sourceArray: any[], paginatorState: { pageIndex: number, pageSize: number }): any[] {
    const start = paginatorState.pageIndex * paginatorState.pageSize;
    return sourceArray.slice(start, start + paginatorState.pageSize);
  }

  public onPaginateInfracoes(event: PageEvent): void {
    this.infracoesPaginator.pageIndex = event.pageIndex;
    this.infracoesPaginator.pageSize = event.pageSize;
    this.atualizarTabelaEspecifica('indicadorInfracoes');
  }

  public onPaginateMultasLocal(event: PageEvent): void {
    this.multasLocalPaginator.pageIndex = event.pageIndex;
    this.multasLocalPaginator.pageSize = event.pageSize;
    this.atualizarTabelaEspecifica('indicadorMultasLocalidade');
  }

  public onPaginateTopMultados(event: PageEvent): void {
    this.topMultadosPaginator.pageIndex = event.pageIndex;
    this.topMultadosPaginator.pageSize = event.pageSize;
    this.atualizarTabelaEspecifica('indicadorVeiculosMaisMultados');
  }

  private atualizarTabelaEspecifica(indicadorNome: string): void {
    this.dashboardController.getIndicadores([indicadorNome], this.currentDataInicial, this.currentDataFinal).subscribe(
      response => {
        const results = response.data?.results || [];
        results.forEach((arr: IndicadorResult[]) => {
          if (!arr || arr.length === 0) return;
          if (arr[0].indicador === indicadorNome) {
            this.processarTabelaIndicador(indicadorNome, arr);
          }
        });
      },
      () => { }
    );
  }

  private processarTabelaIndicador(indicadorNome: string, arr: IndicadorResult[]): void {
    switch (indicadorNome) {
      case 'indicadorInfracoes': {
        this.infracoesDataAll = arr.map(item => ({
          codigoInfracao: item['codigoInfracao'] || '',
          descricao: item['descricao'] || '',
          quantidade: item['qtdInfracoes'] || 0
        }));
        this.infracoesPaginator.length = this.infracoesDataAll.length;
        this.infracoesData = this.paginateData(this.infracoesDataAll, this.infracoesPaginator);
        break;
      }
      case 'indicadorMultasLocalidade': {
        this.multasLocalDataAll = arr.map(item => ({
          local: item['descricao'] || '',
          quantidade: item['qtdMultasLocalidade'] || 0
        }));
        this.multasLocalPaginator.length = this.multasLocalDataAll.length;
        this.multasLocalData = this.paginateData(this.multasLocalDataAll, this.multasLocalPaginator);
        break;
      }
      case 'indicadorVeiculosMaisMultados': {
        this.topMultadosDataAll = arr.map(item => ({
          placa: item['placa'] || '',
          quantidade: item['qtdMultasVeiculo'] || 0
        }));
        this.topMultadosPaginator.length = this.topMultadosDataAll.length;
        this.topMultadosData = this.paginateData(this.topMultadosDataAll, this.topMultadosPaginator);
        break;
      }
    }
  }
}
